import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/image/01.png';
const _hoisted_1 = {
  class: "head"
};
const _hoisted_2 = {
  class: "nav"
};
const _hoisted_3 = ["onClick"];
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'Head',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const navList = ref([{
      name: "首页",
      path: "/"
    }, {
      name: "商家入驻",
      path: "/merchant"
    },
    // {
    //   name: "热点资讯",
    //   path: "/news"
    // },
    {
      name: "帮助中心",
      path: "/help"
    }, {
      name: "商家登录",
      path: "/login"
    }]);
    const isActive = path => {
      if (path === '/') {
        return route.path === '/';
      } else {
        return route.path.startsWith(path);
      }
    };
    const navigateTo = path => {
      if (path == '/login') return window.open('https://admin.xinyuemall.com/index/user/login.html?url=', '_blank');
      router.push(path);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "logo"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => navigateTo(item.path),
          key: index,
          class: _normalizeClass(["nav_name", {
            checked: isActive(item.path)
          }])
        }, _toDisplayString(item.name), 11, _hoisted_3);
      }), 128))])]);
    };
  }
};